import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import MarketingLayout, { type ActivePage } from './MarketingLayout';
import MarketingRoute from './MarketingRoute';

function activePageFor(pathname: string): ActivePage {
  if (pathname.startsWith('/about')) return 'about';
  if (pathname.startsWith('/membership')) return 'membership';
  if (pathname.startsWith('/assessments')) return 'assessments';
  return 'home';
}

/**
 * Layout route for the hero pages (home, about, membership, assessments). Rendering the
 * chrome here, once, and the pages through <Outlet/> keeps the nav and the
 * hero stage mounted across those routes — the photograph dissolves and the
 * nav eases instead of both remounting. Pages that use this shell render
 * their content only, with a <Hero image=…/> declaration.
 */
export default function MarketingShell() {
  const { pathname } = useLocation();
  return (
    <MarketingRoute>
      <MarketingLayout activePage={activePageFor(pathname)} waitlistPopup>
        <Outlet />
      </MarketingLayout>
    </MarketingRoute>
  );
}
